import { IRequestState } from "@app/types";
import { Dayjs } from "dayjs";

export interface IProduct {
  search: any;
  limit: number;
  page: number;
}
export interface IFindLocation {
  id: string;
  address: string;
  name: string;
  city: string;
  country: string;
  zipCode: number;
  lat: number;
  long: number;
}
export interface INewLocation {
  address: string;
  name: string;
  city: string;
  country: string;
  zipCode: number;
  lat: number;
  long: number;
}

export interface IBrands {
  id: number;
  name: string;
  image: string;
}
export interface ICategory {
  id: number;
  name: string;
  image: string;
  parentCategory: any;
}

export interface IAddProduct {
  brand: string;
  brandId?: any;
  isActive?: any;
  modelId?: any;
  transmission?: any;
  driven?: any;
  loanHypothecation?: any;
  loanHyonthecation?: any;
  extraInfo?: any;
  manufacturingYear: string | number | null;
  model: string;
  transmissionType: string;
  engineType: string;
  carTraveled: string | number;
  variant: string;
  color: string;
  description?: string;
  Price: string | number;

  insuranceAvailable: string;
  insuranceType: string;
  expiryDate: Dayjs | string | number | null;
  anyClaimsMade: string;

  usageType: string;
  rcAvailable: string;
  loanAndHyonthecation: string;

  accidentHistory: string;
  fullServiceRecord: string;
  carCondition: string;

  isAvailableForSell: boolean;

  frontView: File | string | null;
  backView: File | string | null;
  leftSideView: File | string | null;
  rightSideView: File | string | null;
  interiorDashboard: File | string | null;
  odometerReading: File | string | null;

  specifications?: Array<{ key: string; value: string }>;

  locationIds?: number[];
}

export interface IProductTypeSlice {
  product: IRequestState;
  brands: IRequestState;
  category: IRequestState;
  addProduct: IRequestState;
  findLocation: IRequestState;
  newLocation: IRequestState;
  productFindById: IRequestState;
  updateProductIdBy: IRequestState;
  deleteProductById: IRequestState;
  allCars: IRequestState;
  soldCar: IRequestState;
}

export interface IBrand {
  brand: string;
  id: number;
}

export type IFuelType = {
  type: string;
  id: number;
};

export const insuranceAvailable = [
  { label: "Yes", id: 1 },
  { label: "No", id: 2 },
];

export const insuranceType = [
  { label: "Comprehensive", id: 1 },
  { label: "Third Party", id: 2 },
];

export const Variant = [
  { label: "Base", id: 1 },
  { label: "Standard", id: 2 },
  { label: "Mid", id: 3 },
  { label: "Sport", id: 4 },
  { label: "Comfort", id: 5 },
  { label: "Top", id: 6 },
];

export const usageType = [
  { label: "Personal", id: 1 },
  { label: "Commercial", id: 2 },
];

export const AccidentHistory = [
  { label: "Accident Free", id: 1 },
  { label: "Minor", id: 2 },
  { label: "Major", id: 3 },
];

export const CarCondition = [
  { label: "Excellent", id: 1 },
  { label: "Good", id: 2 },
  { label: "Average", id: 3 },
  { label: "Needs Work", id: 4 },
];
